import { useEffect } from 'react'

import { useAuth } from '@/auth/AuthProvider'
import { FxIcon } from '@/components/fx'

/**
 * "In der Nutzeransicht kann nichts geändert werden." A write refused with
 * `impersonation_read_only` — wherever in the app it was attempted — lands
 * here instead of on whatever error UI the screen that triggered it would
 * otherwise show. Auto-dismisses so it never becomes one more thing to
 * click away.
 */
export function ImpersonationToast() {
  const { impersonationToast, dismissImpersonationToast } = useAuth()

  useEffect(() => {
    if (!impersonationToast) return
    const timer = setTimeout(dismissImpersonationToast, 5000)
    return () => clearTimeout(timer)
  }, [impersonationToast, dismissImpersonationToast])

  if (!impersonationToast) return null

  return (
    <div
      role="alert"
      className="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-md bg-text px-4 py-3 text-body text-surface shadow-overlay"
    >
      <FxIcon name="lock" size={20} />
      {impersonationToast}
    </div>
  )
}
